import { render } from "./NestedTree.vue?vue&type=template&id=2cbb4dc4"
import script from "./NestedTree.vue?vue&type=script&lang=js"
export * from "./NestedTree.vue?vue&type=script&lang=js"

import "./NestedTree.vue?vue&type=style&index=0&id=2cbb4dc4&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__